module.exports = __webpack_public_path__ + "static/5-0105333fdb352d6cef3208a15c89fd83.jpg";